import Header from "../Components/Header/Header";
import caseOne from './Images/Кейс№1.png';
import caseTwo from './Images/Кейс№2.png';
import { Link } from 'react-router-dom';


const Streams2 = () => {
  return(
    <div className="Page">
      <Header />      
   <div className="Stream--Page--Center">

      <div className="Stream--Page--Center">
        <h1>2 поток Сатурнского Хакатона</h1> 
        <h2>1 - 8 Июля 2024 </h2>
      </div>
      <hr />
      <div className="Block">
        <div>
          <h1>О потоке</h1>
          <p>ИТ смена 2 потока прошла в очном формате на базе Районной Гимназии «Эврика»</p>
          <p>В роли Генерального спонсора выступила Администрация города Олёкминска в лице главы города Сергея Евгеньевича Щеблякова.</p>          
        </div>
        <hr />
        <div>
          <h2>Кейсы</h2>
          <br />
          <div className="Case--Info">
            <h2>Кейс №1: Новостной портал города Олёкминска.</h2>     
            <p>Заказчик: Администрация города</p>       
            <img src={caseOne} />          
          </div>
          <br />
          <div className="Case--Info">
            <h2>Кейс №2: Школьная Пропускная Система.</h2>
            <p>Заказчик: Районная Гимназия «Эврика»</p>
            <img src={caseTwo} />          
          </div>
        </div>
      </div>

      <h1>Презентации команд</h1>

      <div className="Block">
        <div className="Project--Container">
          <div className="Project--Avatar">
            <img width={500}  alt="logo" />          
          </div>
          <div className="Project--Container--Item">
            <div>
              <h2>Команда Pulsar</h2>
              <h3>Олёкминск +</h3>                  
            </div>
            <div>
              <p>Наш проект Олёкминск + решает проблему отсуствия информации об заведениях и спорт-мероприятий у жителей города с помощью расписаний которые имеют рейтинги и уведомления фиксирующих деятельность заведений с социальными активностями города в лаконичном приложений</p>          
            </div>     
            <div>
              <a className="Stream-items--button" href="https://drive.google.com/file/d/1hjjO_cWDeRoOdiN8mEL2RMxBI5potx2e/view?usp=sharing">
                <button>Презентация команды</button>            
              </a>
            </div>      
          </div>          
        </div>
      </div>

      <div className="Block">
        <div className="Project--Container">
          <div className="Project--Avatar">
            <img width={500}  alt="logo" />          
          </div>
          <div className="Project--Container--Item">
            <div>
              <h2>Команда Сатурн</h2>
              <h3>Мой Олёкминск</h3>                  
            </div>
            <div>
              <p>Создать Веб-сайт “Мой Олёкминск”
который помогает ориентироваться в
нашем городе, а также предложит
вам посетить общепит и развлечения</p>          
            </div>     
            <div>

              <a className="Stream-items--button" href="https://drive.google.com/file/d/1FzGh_b4i1VVwPHwJubWyNIHHn7aoh_w0/view?usp=sharing">
                <button>Презентация команды</button>            
              </a>
              
            </div>      
          </div>          
        </div>
      </div>

      <div className="Block">
        <div className="Project--Container">
          <div className="Project--Avatar">
            <img width={500}  alt="logo" />          
          </div>
          <div className="Project--Container--Item">
            <div>
              <h2>Команда BOYZ</h2>
              <h3>School Prime</h3>                  
            </div>
            <div>
              <p>Установка пропускной системы в
школы, которая привязана к
мобильному приложению

Создание мобильного приложения
для школ, в котором будут все
функции, необходимые сотрудникам
школы и ее ученикам</p>          
            </div>     
            <div>

              <a className="Stream-items--button" href="https://drive.google.com/file/d/1Lrc-9WarvswzZdTLh0lz4oRFE3uyC0WR/view?usp=sharing">
                <button>Презентация команды</button>            
              </a>
              
            </div>      
          </div>          
        </div>
      </div>



    </div>      
    </div>
 
  )
}
export default Streams2;
